import React from 'react'

import FormControl from '../FormControl'
import TextFieldWrapper from '../TextField/TextFieldWrapper'
import TextFieldLabel from '../TextField/TextFieldLabel'
import FileInput from './FileInput'
import FieldHelp from '../FieldHelp'

function FileField({
  name,
  id = name,
  label,
  shrinkLabel,
  full,
  error,
  help,
  tip,
  forceTip,
  ...props
}) {
  return (
    <FormControl>
      {({ focused, filled, getInputProps }) => (
        <TextFieldWrapper full={full}>
          {label && (
            <TextFieldLabel
              shrink={shrinkLabel || focused || filled}
              focused={focused}
              htmlFor={id}
              error={error}
            >
              {label}
            </TextFieldLabel>
          )}
          <FileInput
            {...getInputProps({
              ...props,
              error,
              focused,
              filled,
              id,
              name
            })}
          />
          {(focused || forceTip) && tip && <FieldHelp>{tip}</FieldHelp>}
          {help && <FieldHelp error={error}>{help}</FieldHelp>}
        </TextFieldWrapper>
      )}
    </FormControl>
  )
}


export default FileField
